export function trackPageView () {
  if (process.env.REACT_APP_ENV === 'production') {
    // @ts-ignore
    window?.gtag('js', new Date());
    // @ts-ignore
    window?.gtag('config', 'UA-53200829-1');
  }
}
